import contentTypeService from "./contentTypeService";

const contentService = [
    ...contentTypeService
]

export default contentService;